import styled from 'styled-components'
import Text from '../../core/utils/Text'
import { useEffect, useState } from 'react'
import { useMainContext } from "../../core/contexts/main"
import WalletIcon from '../icons/WalletIcon'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import MobileModal from './MobileModal'
import ClipboardListIcon from '../icons/ClipboardListIcon'
import HomeIcon from '../icons/HomeIcon'
import EducationIcon from '../icons/EducationIcon'
import UserSolidIcon from '../icons/UserSolidIcon'
import ArrowSwapIcon from '../icons/ArrowSwapIcon'
import ChartIcon from '../icons/ChartIcon'
import CategoryIcon from '../icons/CategoryIcon'
import MenuMetaBallIcon from '../icons/MenuMeatbalIcon'
import { IoDocumentOutline } from 'react-icons/io5'
import NodesIcon from '../icons/NodesIcon'
import UserGroupIcon from '../icons/UserGroupIcon'
import BellIcon from '../icons/BellIcon'
import TelegramIcon from '../icons/Telegram'

const BottomBar = () => {

	const navigate = useNavigate()
	const location = useLocation()
	const { main: { theme } } = useMainContext()

	const [optionsModal, setOptionsModal] = useState({ open: false, options: null })
	const [active, setActive] = useState(-1)


	useEffect(() => {
		const pathname = location.pathname

		const matchIndex = tabs.findIndex(t =>
			!t.hasOptions && t.href && pathname.startsWith(t.href)
		)

		setActive(matchIndex)
	}, [location.pathname])


	const onTabClicked = (tab, idx) => {
		setActive(idx)

		if (tab.hasOptions) {
			setOptionsModal({ open: true, options: tab.options })
			return
		}

		// normal navigation
		if (tab.href) navigate(tab.href)
	}

	const closeModal = () => {
		setOptionsModal({ open: false, options: null });

		// restore highlight based on actual route
		const pathname = location.pathname;
		const matchedIndex = tabs.findIndex(
			(t) => t.href && pathname.startsWith(t.href)
		);
		setActive(matchedIndex === -1 ? -1 : matchedIndex);
	};

	return (
		<Body>
			<BottomBarWrapper>
				{tabs.map((tab, idx) => {
					const isActive = idx === active

					return (
						<TabItem
							key={idx}
							active={isActive}
							onClick={() => onTabClicked(tab, idx)}
						>
							<tab.icon size={20} color={isActive ? "#FFFFFF" : "#A1A1A1"} />

							{tab.name && (
								<DText color={isActive ? 'dark:#FFC800' : ''}>
									<Text tid={tab.name} />
								</DText>
							)}
						</TabItem>
					)
				})}
			</BottomBarWrapper>

			{/* Modal */}
			{optionsModal.open && (
				<MobileModal
					isOpen={optionsModal.open}
					onClose={closeModal}
					noPadding
					animationConfig={{ bounce: 0.3, mass: 20 }}
				>
					<div className='grid grid-cols-2 gap-5 p-6 pt-0'>
						<div className='col-span-2 text-center w-full'>
							<Text tid={'more-functions'} className='text-2xl text-center' />
						</div>

						{optionsModal.options.map((link, idx) => {
							const { Icon } = link
							return (
								<OptionsItem to={link.href} key={idx}>
									<OptionIcon>
										<Icon size="22" color={theme === 'dark' ? "#FFFFFF" : "#1E1E1E"} />
									</OptionIcon>
									<Text tid={link.tid} className='text-lg' />
									<Text tid={link.desc} className='text-sm opacity-70 ' />
								</OptionsItem>
							)
						})}
					</div>
				</MobileModal>
			)}
		</Body>
	)
}

const MORE_LINKS = [
	// { tid: 'historys', href: '/transactions', desc: 'history-desc', Icon: ChartIcon },
	// { href: '/swap', tid: 'swap', desc: "swap-desc", Icon: ArrowSwapIcon },
	{ href: '/invite-friends', tid: 'invite-friends', desc: "invite-friends-desc", Icon: UserGroupIcon },
	{ href: '/notifications', tid: 'notifications', desc: "notifications-desc", Icon: BellIcon },
	{ href: '/telegram', tid: 'telegram', desc: "telegram-desc", Icon: TelegramIcon },
	// { href: '/profile', tid: 'profile', desc: "profile-desc", Icon: UserSolidIcon },
]

const tabs = [
	{ name: 'dashboard', icon: CategoryIcon, href: '/assistant/crypto' },
	{ name: 'plans', icon: NodesIcon, href: '/plans' },
	{ name: 'historys', icon: ChartIcon, href: '/transactions' },
	// { name: 'wallet', icon: WalletIcon, href: '/wallet' },
	{ name: 'more', icon: MenuMetaBallIcon, hasOptions: true, options: MORE_LINKS },
]

/* Styled Components */

const Body = styled.div`
  position: fixed;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 385px;
  height: 70px;
  direction: ${props => (props.theme.english ? 'ltr' : 'rtl')};
  background-color: #24132599;
  border-radius: 999px;
  box-shadow: 0 0px 6px 4px rgba(0, 0, 0, 0.16);
  padding: 0px 16px;
  z-index: 1001;
  backdrop-filter: blur(6px);
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    padding: 1px;
    border-radius: inherit;
    background: linear-gradient(90deg, #3C096B, #C27AFF, #3C096B);
    -webkit-mask: 
      linear-gradient(#fff 0 0) content-box, 
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
            mask-composite: exclude;
    pointer-events: none;
  }
`

const BottomBarWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 100%;
`

const DText = styled.div`
	font-size: 0.75rem;
  	color: ${props => props.color || props.theme.color};

	@media screen and (max-width: 420px) {
	font-size: 0.7rem;
		
	}
`

const TabItem = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	height: 50px;
	width: 80px;
	border-radius: 999px;
	gap: 4px;
	background-color: ${props => props.active ? "#C27AFF" : "transparent"};
	cursor: pointer;
`

const OptionsItem = styled(Link)`
	display: flex;
	flex-direction: column;
	justify-content: start;
	align-items: start;
	gap: 4px;
	padding: 16px;
	border-radius: 12px;
	background-color: ${props => props.theme.cardBg};
`

const OptionIcon = styled.div`
		display: flex;
	justify-content: center;
	align-items: center;
  	width: 32px;
	height: 32px;
	border-radius: 8px;
	background-color: #FE8B65;
`

export default BottomBar
